// Gold, Orange[x], Red [x], Green [x]
// Renamed from yellow to gold
import React from 'react';
import { useState, useEffect } from 'react';
import '../App.css';
import './cookoff.css';
import { Form, Icon, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { storageUtils } from '../utils/localStorage';
import LoadingScreen from './LoadingScreen';
import { recordCompletion } from '../utils/groups';

const GROUP = 'gold';

export default function Gold() {
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState();
  const [userLoggedIn, setuserLoggedIn] = useState(false);
  const [completedItems, setcompletedItems] = useState([]);
  const [showLoadingScreen, setShowLoadingScreen] = useState(false);

  const [showMessage, setShowMessage] = useState();
  const [isAssignedHere] = useState(() => storageUtils.hasGroupAccess(GROUP));

  // const userEmail = 'dom@test.com';
  let chilliName = 'default';

  const logIn = () => {
    console.log('login', userEmail);
    if (userEmail !== '') {
      // Show loading screen for new users
      setShowLoadingScreen(true);

      // Hide loading screen after 4.5 seconds
      setTimeout(() => {
        setShowLoadingScreen(false);
      }, 4500);

      storageUtils.setUser(userEmail);

      console.log('---> users name: ', userName);

      storageUtils.setUserName(userName);
      setuserLoggedIn(true);
    }
  };

  const putItemsInLocalStorage = (item) => {
    console.log('!!!! >>>> putItemsInLocalStorage CALLED');

    // Use the utility function to add the item
    const updatedItems = storageUtils.addCompletedItem(item);

    // Update state
    setcompletedItems(updatedItems);

    console.log('Ive updated completed items');
    setTimeout(() => {
      console.log('completedItems update in state... ', completedItems);
      console.log(
        'Current year completed items:',
        storageUtils.getCompletedItems(),
      );
    }, 3000);
  };

  const setChilliName = (value) => {
    chilliName = value;
    console.log('chilliname is now', chilliName);
  };

  /*
  const listOfChillis = [
    { id: '4', n: 'Mark Parcel', name: "Grammy's Smack Your Lips Chilli" },
    { id: '8', n: 'Stephanie Teeter', name: 'Mean Jean' },
    {
      id: '12',
      n: 'Michael Perrino',
      name: 'Chili While Camping, it’s Intents',
    },
    { id: '16', n: 'Jason Smith', name: 'Wood Pros Chili' },

    //     #4	Mark Parcel	Grammy's Smack Your Lips Chilli	Gold
    // #8	Stephanie Teeter	Mean Jean	Gold
    // #12	Michael Perrino	Oppenheimer's A-Bomb 2.0	Gold
    // #16	Jason Smith	Wood Pros Chili	Gold
  ];
  */

  const listOfChillis = [
    { id: '4', n: 'Zach Johnson', name: 'Business Trip' },
    { id: '8', n: "Jessie O'Connor", name: 'Chili Nelson' },
    { id: '12', n: 'Bob Roybal', name: 'Uncle Baby Birdees 2.0' },
    { id: '16', n: 'Jimmy Buczynski', name: 'Pol-Skis Chili' },
  ];

  const signUserOut = () => {
    console.log('signUserOut');
    setUserName(undefined);
    setUserEmail('');
    setcompletedItems([]); // Clear state

    // Clear user data but leave completed items (they're year-specific now)
    storageUtils.clearUser();

    setuserLoggedIn(false);
    setShowMessage('logout');
  };

  useEffect(() => {
    console.log('useEffect');
    const user = storageUtils.getUser();
    const userName = storageUtils.getUserName();

    if (user) {
      console.log('email is here in local storage');
      setUserEmail(user);

      if (userName) {
        setUserName(userName);
      }

      setuserLoggedIn(true);
    }

    // Get completed items for current year
    const completedItemsForYear = storageUtils.getCompletedItems();
    if (completedItemsForYear.length > 0) {
      console.log(
        `USE EFFECT: This user has voted for items in ${storageUtils.getCurrentYear()}. Setting state`,
      );
      setcompletedItems(completedItemsForYear);

      setTimeout(() => {
        console.log(
          'USE EFFECT: completedItems update in state... ',
          completedItemsForYear,
        );
      }, 3000);
    }

    console.log(
      `completedItems for ${storageUtils.getCurrentYear()} >>`,
      completedItemsForYear,
    );

    const query = new URLSearchParams(window.location.search);
    console.log('url parameters', query);
    console.log(`window.location.search ${window.location.search}`);
    const completed = query.get('completed');
    console.log('completed url parameter: ', completed);

    if (completed) {
      console.log('there is an chili id in completed.', completed);
      putItemsInLocalStorage(completed);
      recordCompletion({
        email: user || query.get('ue'),
        name: userName,
        group: GROUP,
        chiliId: completed,
      });
    }

    const userEmailWhoCompletedGrading = query.get('ue');
    console.log(`userEmailWhoCompletedGrading ${userEmailWhoCompletedGrading}`);

    const signout = query.get('signout');
    if (signout === 'true') {
      console.log('there is a parameter in the URL to log out.');
      signUserOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LoadingScreen
        isVisible={showLoadingScreen}
        subtitle="Get ready to taste and vote on some amazing chilis!"
      />

      <main className="App-header cookoff-page">
        <div
          className={userLoggedIn ? 'content cookoff-content-wide' : 'content'}
        >
          <div className="top-half"></div>

          <div className="cookoff-badge-wrap">
            <img
              className="cookoff-badge"
              src="hot-pepper.png"
              alt="Hot pepper icon"
              width="240"
              height="240"
            ></img>
          </div>

          <div className="cookoff-intro">
            {userLoggedIn && (
              <span className="cookoff-group cookoff-group-gold">
                Gold group
              </span>
            )}
            <h1 className="cookoff-title">Welcome to JJ's Chili Cookoff!</h1>
            {userLoggedIn && (
              <p className="cookoff-subtitle">
                Time to eat and score each chilli below.
              </p>
            )}
            {!isAssignedHere && (
              <Message warning size="small" className="cookoff-notice">
                Make sure you scan the latest QR code.
              </Message>
            )}
          </div>

          {!userLoggedIn && (
            <div className="cookoff-login">
              <p className="cookoff-login-prompt">
                Tasters, enter your email to get started.
              </p>

              <div className="login-form-container cookoff-form">
                <Form onSubmit={logIn}>
                  <Form.Field>
                    <label htmlFor="cookoff-name">Full Name</label>
                    <input
                      id="cookoff-name"
                      placeholder="Full Name"
                      autoComplete="name"
                      onChange={(event) => setUserName(event.target.value)}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label htmlFor="cookoff-email">Email</label>
                    <input
                      id="cookoff-email"
                      placeholder="BiebsWasHere@gmail.com"
                      inputMode="email"
                      autoComplete="email"
                      autoCapitalize="none"
                      autoCorrect="off"
                      spellCheck={false}
                      onChange={(event) => setUserEmail(event.target.value)}
                    />
                  </Form.Field>

                  <div className="cookoff-actions">
                    <button className="email-btn" type="submit">
                      Start
                    </button>
                  </div>
                  {/* <Button type='submit'>Submit</Button> */}
                </Form>
              </div>
            </div>
          )}

          {userLoggedIn && (
            <ul className="cookoff-list">
              {listOfChillis.map(function (item, id) {
                const typeformUrl =
                  'https://form.typeform.com/to/RI77FMRU#chilliname=' +
                  item.name +
                  '&chilliid=' +
                  item.id +
                  '&useremail=' +
                  userEmail +
                  '&username=' +
                  userName;
                const isDone = completedItems.includes(item.id);

                return (
                  <li
                    className={
                      isDone ? 'cookoff-card is-done' : 'cookoff-card'
                    }
                    key={item.id}
                  >
                    <a
                      className="cookoff-card-link"
                      href={typeformUrl}
                      onClick={() => {
                        setChilliName(item.name);
                      }}
                    >
                      <span className="cookoff-pot">
                        {isDone ? (
                          <img
                            src="pot-icon-done.png"
                            alt="Completed pot icon"
                            width="300"
                            height="272"
                          ></img>
                        ) : (
                          <img
                            src="pot-icon.png"
                            alt="Pot icon"
                            width="300"
                            height="272"
                          ></img>
                        )}
                        <span className="cookoff-pot-number">{item.id}</span>
                      </span>
                      <span className="cookoff-card-name">{item.name}</span>
                      {isDone ? (
                        <span className="cookoff-card-done" aria-hidden="true">
                          ✅
                        </span>
                      ) : (
                        <span
                          className="cookoff-card-chevron"
                          aria-hidden="true"
                        ></span>
                      )}
                    </a>
                  </li>
                );
              })}
            </ul>
          )}

          {showMessage === 'logout' && (
            <Message color="blue" className="cookoff-notice cookoff-logout">
              Logged out. Please log back in with the same email you used last
              time
            </Message>
          )}

          <footer className="cookoff-footer">
            {userLoggedIn && userEmail && (
              <p className="cookoff-account">
                Logged in as {userName} ({userEmail})
              </p>
            )}
            <Link
              to="/settings"
              className="cookoff-settings"
              aria-label="Settings"
            >
              <Icon name="setting" />
            </Link>
          </footer>
        </div>
      </main>
    </>
  );
}
